import { render, staticRenderFns } from "./MainAdminPage.vue?vue&type=template&id=32a3abf1&scoped=true"
import script from "./MainAdminPage.vue?vue&type=script&lang=js"
export * from "./MainAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3abf1",
  null
  
)

export default component.exports